import { withStyles } from '@material-ui/core';

import PurchaseItem from './component';
import styles from './styles';

export default withStyles(styles)(PurchaseItem);
